<template>
  <div v-if="view_type" class="missions__list" :class="`type--${view_type}`">
    <MissionsListHeader :viewType="view_type" @setViewContent="setViewContent" />
    <vue-scroll
      ref="scroll"
      :key="view_type"
      class="bp-page__scroll"
      :ops="scroll_options[view_type]"
      @handle-scroll="handleScroll"
    >
      <div class="missions__list__container" :class="`type--${view_type}`">
        <MissionsListOneTable v-if="view_type === 'table'" />
        <MissionsListOne
          v-for="(mission, index) in getMissionList"
          v-else
          :key="index"
          :missionData="mission"
          :index="index"
        /></div
    ></vue-scroll>
    <template v-if="showArrows">
      <div
        :key="`prev_${scroll}`"
        class="bp-page__arrow bp-page__arrow--prev"
        :class="{ 'type--disabled': isArrowDisabled(0) }"
      >
        <button @click="scrollPage('left')">
          <i class="icon icon-arrow-big"></i>
        </button>
      </div>
      <div
        :key="`next_${scroll}`"
        class="bp-page__arrow bp-page__arrow--next"
        :class="{ 'type--disabled': isArrowDisabled(1) }"
      >
        <button @click="scrollPage('right')">
          <i class="icon icon-arrow-big"></i>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import MissionsListHeader from "./MissionsListHeader";
import MissionsListOne from "./MissionsListOne";
import MissionsListOneTable from "./MissionsListOneTable";

import ScrollArrowMixin from "@/components/Common/ScrollArrowMixin";
import WindowSizeMixin from "@/components/Common/WindowSizeMixin";

import { mapGetters } from "vuex";

const VIEW_TYPE_COOKIE = "bp_missions_view_mode";

export default {
  name: "MissionsList",
  components: {
    MissionsListHeader,
    MissionsListOne,
    MissionsListOneTable,
  },

  mixins: [ScrollArrowMixin, WindowSizeMixin],

  data() {
    return {
      view_type: null, // Can be "decor" or "table"
      scroll_options: {
        table: {
          scrollPanel: {
            scrollingX: false,
          },
          rail: {
            background: "rgba(255, 255, 255, .15)",
            opacity: 1,
            size: "10px",
            specifyBorderRadius: "0px",
          },
          bar: {
            background: "#DCDCDC",
            opacity: 1,
            size: "4px",
            specifyBorderRadius: "0px",
            keepShow: true,
          },
        },
        decor: {
          scrollPanel: {
            scrollingY: false,
          },
          rail: {
            background: "rgba(255, 255, 255, .15)",
            opacity: 1,
            size: "20px",
            specifyBorderRadius: "0px",
          },
          bar: {
            background: "#DCDCDC",
            opacity: 1,
            size: "20px",
            specifyBorderRadius: "0px",
            keepShow: true,
          },
          vuescroll: {
            wheelDirectionReverse: true,
          },
        },
      },
    };
  },

  computed: {
    ...mapGetters("missions", ["getMissionList"]),

    showArrows() {
      return this.view_type === "decor" && this.isDesktop;
    },
  },

  watch: {
    window_width() {
      if (this.view_type === "table" && this.isMobile) {
        this.view_type = "decor";
      }
      if (this.view_type === "decor" && !this.isMobile) {
        this.view_type = "table";
      }
    },
  },

  created() {
    // this.view_type = Cookies.get(VIEW_TYPE_COOKIE) || "decor";
    this.view_type = "table";
  },

  methods: {
    setViewContent(type) {
      Cookies.set(VIEW_TYPE_COOKIE, type, { expires: 100 });

      this.view_type = type;
    },
  },
};
</script>
